import { useIsAuthenticated } from "@/context/AuthContext"
import WebComponentTest from "@/screens/web-component/WebComponentTest"
import React from "react"
import * as portals from "react-reverse-portal"
import { Redirect, Route, Switch } from "react-router-dom"
import { useModalPortal } from "../../../context/ModalPortalContext"
import Login from "../Login"
import SetPassword from "../set-password/SetPassword"
import SSOLogin from "../SSOLogin"

const loadAuthenticatedApp = () => import("../../../components/authenticated-app/AuthenticatedApp.jsx")
const AuthenticatedApp = React.lazy(loadAuthenticatedApp)

export interface ILoginRoutes {}

const LoginRoutes: React.FC<ILoginRoutes> = ({}: ILoginRoutes) => {
  const isAuthenticated = useIsAuthenticated()

  React.useEffect(() => {
    loadAuthenticatedApp()
  }, [])

  const { portalNode } = useModalPortal()

  return (
    <>
      <portals.OutPortal node={portalNode} />
      <Switch>
        <Route
          path="/callback/:accessToken/:refreshToken"
          render={(routerProps) =>
            isAuthenticated ? (
              <>
                {(() => {
                  const searchParams = new URLSearchParams(routerProps.location.search)
                  const redirect = searchParams.get("redirect") || "/"
                  const attributes = searchParams.get("attributes")
                  let redirectWithParams =
                    redirect +
                    (redirect.includes("?") ? "&" : "?") +
                    `accessToken=${routerProps.match.params.accessToken}`
                  if (attributes) {
                    redirectWithParams += `&attributes=${attributes}`
                  }
                  return <Redirect to={redirectWithParams} />
                })()}
              </>
            ) : (
              <SSOLogin
                accessToken={routerProps.match.params.accessToken}
                refreshToken={routerProps.match.params.refreshToken}
                redirect={new URLSearchParams(routerProps.location.search).get("redirect") || undefined}
              />
            )
          }
        />
        <Route
          path="/set-password/:key"
          render={(routerProps) => <SetPassword token={routerProps.match.params.key} isReset={false} />}
        />
        <Route
          path="/reset-password/:key"
          render={(routerProps) => <SetPassword token={routerProps.match.params.key} isReset={true} />}
        />
        <Route path="/web-component-test" render={() => <WebComponentTest />} />

        <Route path="" render={() => (isAuthenticated ? <AuthenticatedApp /> : <Login />)} />
      </Switch>
    </>
  )
}

export default LoginRoutes
